export const allowedPortForProducts = {
  'Invoice': {
    ports: ['SalesRep', 'Mindsight'],
    by: 'portProducts'
  },
  'ConsignmentOrder': {
    ports: ['SalesRep', 'Mindsight'],
    by: 'portProducts'
  },
  'OrderRequest': {
    ports: ['SalesRep', 'Mindsight'],
    by: 'portProducts'
  },
  'OrderReturn': {
    ports: ['SalesRep', 'Mindsight'],
    by: 'portProducts'
  },
};

export type IAllowedPortProducts = typeof allowedPortForProducts;